import React, { Fragment } from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { observer } from 'mobx-react';
import { getDomIdByFieldKey } from '../../../../util/typeUtil';
import { WeaSelect, WeaInput, WeaLocaleProvider } from 'ecCom';
import { message, Modal } from 'antd';
import _ from 'lodash';
const getLabel = WeaLocaleProvider.getLabel;

@observer
export default class SelLevelElement extends React.Component<ExcelTableCellProps, any>{
    render() {
        const { cell, form, card, className/*, excel*/ } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        let fieldName = getDomIdByFieldKey(bindObj.path);
        const { secretTimeDefValue, secretTimeDefStyle } = card;
        const { value, viewAttr: _viewAttr, isEdit, isMandatory, options: filtedOptions } = bindObj.bind();
        const { value: value1 = '' } = form.$('field-10').bind();
        let { options, fieldshowtypes } = card.getFieldProps(path);
        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        let realOptions = _.isArray(filtedOptions) ? filtedOptions : options;
        realOptions = realOptions.filter(f => f.cancel != '1');
        if (viewAttr == '1') {
            return (
            <div id={"select" + fieldName} className={`${'cube-card-editformitem2'} fieldValue ${className}`}
                data-fieldattr={viewAttr} data-fieldmark={fieldName} 
                style={{float:'left', ...cell.cellProps.style}}
            >
                <WeaSelect ecId={`${this && this.props && this.props.ecId || ''}_WeaSelect@a0hxy1`}
                    className='cube-card-select'
                    options={[{ key: '', showname: '' }, ...realOptions]}
                    fieldName={fieldName}
                    viewAttr={1}
                    fieldshowtypes={fieldshowtypes}
                    value={value}
                    onChange={bindObj.onChange}
                    style={{float:'left'}}
                    // {...layoutProps}
                    supportCancel
                />
                {['1','2'].indexOf(value)>-1&&secretTimeDefStyle[value]=='0'&&<div style={{ display:'inline-block', marginRight:12, height:28 }}>
                    <i style={{margin:'0px 5px'}} className="icon-coms-Collection2" />
                    <span style={{display:'inline-block',marginTop: 1,marginBottom:1}}>{value1||secretTimeDefValue[value]}</span>
                </div>}
            </div>)
        }
        return (
            <Fragment ecId={`${this && this.props && this.props.ecId || ''}_Fragment@3d2vcr`}>
                <div id={"select" + fieldName} className={`${'cube-card-editformitem2'} fieldValue ${className}`}
                    data-fieldattr={viewAttr} data-fieldmark={fieldName} 
                    style={{float:'left', ...cell.cellProps.style}}
                >
                    <WeaSelect ecId={`${this && this.props && this.props.ecId || ''}_WeaSelect@f7pubx`}
                        className='cube-card-select'
                        options={[{ key: '', showname: '' }, ...realOptions]}
                        fieldName={fieldName}
                        viewAttr={viewAttr}
                        fieldshowtypes={fieldshowtypes}
                        value={value}
                        onChange={(v) => {
                            if (value && (value < v || v=='')) { // 高密级切换低密级，需清除数据
                                const mythis = this;
                                const _secretTime = form.$('field-10').value;
                                Modal.confirm({
                                    title: getLabel('131329','信息确认'),
                                    content: getLabel('530633','变更密级，高于当前卡片密级的关联资源会被清除，附件密级将自动调整为修改的密级，确定要调整吗？'),
                                    onOk() {
                                        /**   明细清空时需保留dtl_id  start ****/
                                        const _dtlIdArr = {};
                                        form.map(field=>{
                                            if (field.key.startsWith('detail_')) {
                                                const _detailArr = _.map(field.value, 'dtl_id');
                                                _dtlIdArr[field.key] = _detailArr;
                                            }
                                        });
                                        mythis.props.card.cubeForm.clearCubeFields();
                                        for (let key in _dtlIdArr) {
                                            form.$(key).map((item, index) => {
                                                form.setValue(`${item.path}.dtl_id`, _dtlIdArr[key][index], true)
                                            });
                                        }
                                        /*****   end   *****/
                                        mythis.changeSeclevelValue(bindObj, v);
                                    },
                                    onCancel() {
                                        mythis.changeSeclevelValue(bindObj, value, _secretTime);
                                    }
                                });
                            }
                            this.changeSeclevelValue(bindObj, v);
                        }}
                        style={{width:100}}
                        // {...layoutProps}
                        supportCancel
                    />
                </div>
                {
                    ['1','2'].indexOf(value)>-1&&(
                        <div id={"selectfield-10"} className={`${'cube-card-editformitem2'} fieldValue ${(form.$('field-10').isValid||!!form.$('field-10').value) ? 'cube-check-valid' : 'cube-check-error'}`}
                            data-fieldattr={viewAttr} data-fieldmark={'field-10'} 
                            style={{float:'left', marginLeft: 10, ...cell.cellProps.style}}
                        >
                            <WeaInput ecId={`${this && this.props && this.props.ecId || ''}_WeaInput@7mkgke`}
                                helpfulTip={getLabel('528340','保密期限填写格式：3个月、10年、20年、长期…不能是纯数字')}
                                value={value1}
                                style={{width:143}}
                                viewAttr={viewAttr}
                                onChange={form.$('field-10').onChange}
                                onBlur={this.handleInputBlur}
                            />
                        </div>
                    )
                }
            </Fragment>
        )
    }
    handleInputBlur = (v) => {
        const { form } = this.props;
        if (/^\d+$/.test(v)) {
            message.error(getLabel('530634','保密期限不能是纯数字'));
            form.$('field-10').onChange('');
        }
        if (!v) {
            message.error(getLabel('530064','请填写保密期限'));
        }
    }

    changeSeclevelValue = (bindObj, v, secretTime?) => {
        const { form, card: { secretTimeDefValue } } = this.props;
        bindObj.onChange(v);
        if (secretTime) {
            form.$('field-10').onChange(secretTime);
        } else {
            switch(v) {
                case '1': form.$('field-10').onChange(secretTimeDefValue[v]);break;
                case '2': form.$('field-10').onChange(secretTimeDefValue[v]);break;
                default: form.$('field-10').onChange('10年');break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/seclevel-element/index.tsx